import EmblaCarousel from "embla-carousel";

const queryString = window.location.search;
const urlParams = new URLSearchParams(queryString);
const _variant = urlParams.get("variant");

if (
  window.location.pathname.includes("/products/") &&
  document.querySelector(".embla-pdp__viewport")
) {
  const addThumbBtnsClickHandlers = (emblaApiMain, emblaApiThumb) => {
    const slidesThumbs = emblaApiThumb.slideNodes();

    const scrollToIndex = slidesThumbs.map(
      (_, index) => () => emblaApiMain.scrollTo(index),
    );

    slidesThumbs.forEach((slideNode, index) => {
      slideNode.addEventListener("click", scrollToIndex[index], false);
    });

    return () => {
      slidesThumbs.forEach((slideNode, index) => {
        slideNode.removeEventListener("click", scrollToIndex[index], false);
      });
    };
  };

  const addToggleThumbBtnsActive = (emblaApiMain, emblaApiThumb) => {
    const slidesThumbs = emblaApiThumb.slideNodes();

    const toggleThumbBtnsState = () => {
      emblaApiThumb.scrollTo(emblaApiMain.selectedScrollSnap());
      const previous = emblaApiMain.previousScrollSnap();
      const selected = emblaApiMain.selectedScrollSnap();
      slidesThumbs[previous].classList.remove("embla-thumbs__slide--selected");
      slidesThumbs[selected].classList.add("embla-thumbs__slide--selected");
    };

    emblaApiMain.on("select", toggleThumbBtnsState);
    emblaApiThumb.on("init", toggleThumbBtnsState);

    return () => {
      const selected = emblaApiMain.selectedScrollSnap();
      slidesThumbs[selected].classList.remove("embla-thumbs__slide--selected");
    };
  };

  const addTogglePrevNextBtnsActive = (emblaApiMain, prevBtn, nextBtn) => {
    const togglePrevNextBtnsState = () => {
      if (emblaApiMain.canScrollPrev()) prevBtn.removeAttribute("disabled");
      else prevBtn.setAttribute("disabled", "disabled");

      if (emblaApiMain.canScrollNext()) nextBtn.removeAttribute("disabled");
      else nextBtn.setAttribute("disabled", "disabled");
    };

    emblaApiMain
      .on("select", togglePrevNextBtnsState)
      .on("init", togglePrevNextBtnsState)
      .on("reInit", togglePrevNextBtnsState);

    return () => {
      prevBtn.removeAttribute("disabled");
      nextBtn.removeAttribute("disabled");
    };
  };

  const addPrevNextBtnsClickHandlers = (emblaApiMain, prevBtn, nextBtn) => {
    const scrollPrev = () => emblaApiMain.scrollPrev();
    const scrollNext = () => emblaApiMain.scrollNext();
    prevBtn.addEventListener("click", scrollPrev, false);
    nextBtn.addEventListener("click", scrollNext, false);

    const removeTogglePrevNextBtnsActive = addTogglePrevNextBtnsActive(
      emblaApiMain,
      prevBtn,
      nextBtn,
    );

    return () => {
      removeTogglePrevNextBtnsActive();
      prevBtn.removeEventListener("click", scrollPrev, false);
      nextBtn.removeEventListener("click", scrollNext, false);
    };
  };

  const OPTIONS = {loop: true};
  const OPTIONS_THUMBS = {
    containScroll: "keepSnaps",
    dragFree: true,
  };

  const emblaNode = document.querySelector(".product-main-swiper");

  const viewportNodeMainCarousel = document.querySelector(
    ".embla-pdp__viewport",
  );
  const viewportNodeThumbCarousel = document.querySelector(
    ".embla-thumbs__viewport",
  );
  const emblaApiMain = EmblaCarousel(viewportNodeMainCarousel, OPTIONS);
  const emblaApiThumb = EmblaCarousel(
    viewportNodeThumbCarousel,
    OPTIONS_THUMBS,
  );

  window.emblaApiMain = emblaApiMain;

  const initZoomButton = () => {
    const zoomBtn = document.querySelector(".product-gallery-zoom-btn");
    const zoomModal = document.querySelector(".product-gallery-zoom-modal");
    const zoomClose = document.querySelector(".product-gallery-zoom-close");
    const zoomContainer = zoomModal
      ? zoomModal.querySelector(".embla-zoom__container")
      : null;
    const thumbnailsContainer = zoomModal
      ? zoomModal.querySelector(".product-gallery-zoom-thumbnails")
      : null;

    if (!zoomBtn || !zoomModal || !zoomContainer) {
      return;
    }

    let emblaZoomApi = null;

    const getAllImages = () => {
      const allSlides = document.querySelectorAll(
        ".embla-pdp__viewport .embla__slide",
      );

      const images = [];

      if (allSlides.length > 0) {
        allSlides.forEach((slide) => {
          const img = slide.querySelector("img");
          if (img && img.src) {
            images.push(img.src);
          }
        });
      } else {
        // Fallback for single image products
        const singleImage = document.querySelector(
          ".product-main__top-gallery-image-wrapper img",
        );
        if (singleImage && singleImage.src) {
          images.push(singleImage.src);
        }
      }

      return images;
    };

    const getLargeImageSrc = (src) => {
      let largeImageSrc = src.replace(/([?&])width=\d+/, "$1width=2000");

      if (!largeImageSrc.includes("width=")) {
        if (largeImageSrc.includes("?")) {
          largeImageSrc += "&width=2000";
        } else {
          largeImageSrc += "?width=2000";
        }
      }

      return largeImageSrc;
    };

    const getThumbImageSrc = (src) => {
      let thumbSrc = src.replace(/([?&])width=\d+/, "$1width=150");
      if (!thumbSrc.includes("width=")) {
        if (thumbSrc.includes("?")) {
          thumbSrc += "&width=150";
        } else {
          thumbSrc += "?width=150";
        }
      }
      return thumbSrc;
    };

    const createZoomSlides = (images) => {
      zoomContainer.innerHTML = "";
      images.forEach((src) => {
        const slide = document.createElement("div");
        slide.className = "embla-zoom__slide";

        const img = document.createElement("img");
        img.src = getLargeImageSrc(src);
        img.alt = "Product image";
        img.style.maxWidth = "100%";
        img.style.maxHeight = "80vh";
        img.style.objectFit = "contain";

        slide.appendChild(img);
        zoomContainer.appendChild(slide);
      });
    };

    const createThumbnails = (images, activeIndex = 0) => {
      if (!thumbnailsContainer) {
        return;
      }

      thumbnailsContainer.innerHTML = "";
      images.forEach((src, index) => {
        const thumb = document.createElement("div");
        thumb.className = "product-gallery-zoom-thumb";
        if (index === activeIndex) {
          thumb.classList.add("active");
        }

        const thumbImg = document.createElement("img");
        thumbImg.src = getThumbImageSrc(src);
        thumbImg.alt = `Thumbnail ${index + 1}`;

        thumb.appendChild(thumbImg);
        thumb.addEventListener("click", (e) => {
          e.stopPropagation();
          if (emblaZoomApi) {
            emblaZoomApi.scrollTo(index);
          }
        });
        thumbnailsContainer.appendChild(thumb);
      });
    };

    const updateActiveThumbnail = () => {
      if (!emblaZoomApi) {
        return;
      }

      const selectedIndex = emblaZoomApi.selectedScrollSnap();

      const thumbs = thumbnailsContainer.querySelectorAll(
        ".product-gallery-zoom-thumb",
      );

      thumbs.forEach((thumb, i) => {
        thumb.classList.toggle("active", i === selectedIndex);
      });
    };

    const openZoom = () => {
      const allImages = getAllImages();
      const currentIndex = emblaApiMain ? emblaApiMain.selectedScrollSnap() : 0;

      if (allImages.length > 0) {
        createZoomSlides(allImages);

        const zoomViewport = zoomModal.querySelector(".embla-zoom__viewport");

        if (EmblaCarousel && zoomViewport) {
          emblaZoomApi = EmblaCarousel(zoomViewport, {
            loop: false,
            startIndex: currentIndex,
          });

          createThumbnails(allImages, currentIndex);

          emblaZoomApi.on("select", updateActiveThumbnail);
        }

        zoomModal.classList.add("active");
        document.body.style.overflow = "hidden";
      }
    };

    const closeZoom = () => {
      if (emblaZoomApi) {
        emblaZoomApi.destroy();
        emblaZoomApi = null;
      }
      zoomModal.classList.remove("active");
      document.body.style.overflow = "";
    };

    zoomBtn.addEventListener("click", openZoom);

    zoomClose.addEventListener("click", (e) => {
      e.stopPropagation();
      closeZoom();
    });

    zoomModal.addEventListener("click", (e) => {
      if (e.target === zoomModal) {
        closeZoom();
      }
    });

    const zoomContent = zoomModal.querySelector(
      ".product-gallery-zoom-content",
    );
    if (zoomContent) {
      zoomContent.addEventListener("click", (e) => {
        e.stopPropagation();
      });
    }

    document.addEventListener("keydown", (e) => {
      if (e.key === "Escape" && zoomModal.classList.contains("active")) {
        closeZoom();
      }
    });
  };

  initZoomButton();

  const prevBtn = emblaNode.querySelector(".embla__button--prev");
  const nextBtn = emblaNode.querySelector(".embla__button--next");

  const removeThumbBtnsClickHandlers = addThumbBtnsClickHandlers(
    emblaApiMain,
    emblaApiThumb,
  );

  const removeToggleThumbBtnsActive = addToggleThumbBtnsActive(
    emblaApiMain,
    emblaApiThumb,
  );

  const removePrevNextBtnsClickHandlers = addPrevNextBtnsClickHandlers(
    emblaApiMain,
    prevBtn,
    nextBtn,
  );

  // Initialize dots carousel
  const dotsViewport = document.querySelector(".embla-dots__viewport");
  const dotsContainer = document.querySelector(".embla-dots__container");
  // console.log("Dots container found:", dotsContainer);
  // console.log("EmblaApiMain:", emblaApiMain);

  let emblaApiDots = null;

  if (dotsContainer) {
    const createDots = () => {
      const slideCount = emblaApiMain.slideNodes().length;
      console.log("Creating dots, slide count:", slideCount);
      dotsContainer.innerHTML = "";

      for (let i = 0; i < slideCount; i++) {
        const dotSlide = document.createElement("div");
        dotSlide.className = "embla-dots__slide";

        const dot = document.createElement("button");
        dot.className = "product-main__gallery-dot";
        dot.setAttribute("aria-label", `Go to slide ${i + 1}`);
        dot.addEventListener("click", () => {
          emblaApiMain.scrollTo(i);
          // Auto-scroll dots to keep active dot visible (10 dots per view)
          if (emblaApiDots) {
            const targetIndex = Math.max(0, i - 5); // Center the clicked dot (5 dots on each side)
            emblaApiDots.scrollTo(targetIndex);
          }
        });

        dotSlide.appendChild(dot);
        dotsContainer.appendChild(dotSlide);
      }

      // Initialize dots carousel if more than 10 dots
      if (slideCount > 10) {
        const OPTIONS_DOTS = {
          containScroll: "keepSnaps",
          dragFree: true,
          slidesToScroll: 1,
        };
        emblaApiDots = EmblaCarousel(dotsViewport, OPTIONS_DOTS);
      }

      // console.log("Dots created: ", dotsContainer.children.length);
    };

    const updateDots = () => {
      const dots = dotsContainer.querySelectorAll(".product-main__gallery-dot");
      const selectedIndex = emblaApiMain.selectedScrollSnap();

      console.log(
        "Updating dots, selectedIndex:",
        selectedIndex,
        "total dots:",
        dots.length,
      );

      dots.forEach((dot, index) => {
        const isActive = index === selectedIndex;
        dot.classList.toggle("active", isActive);
        // console.log(`Dot ${index}: active = ${isActive}`);
      });

      // Auto-center active dot in dots carousel (10 dots per view)
      if (emblaApiDots && dots.length > 10) {
        const targetIndex = Math.max(0, selectedIndex - 5); // Center the active dot (5 dots on each side)
        emblaApiDots.scrollTo(targetIndex);
      }
    };

    emblaApiMain.on("init", () => {
      createDots();
      updateDots(); // Call updateDots immediately after creating dots
    });
    emblaApiMain.on("select", updateDots);
    emblaApiMain.on("reInit", () => {
      createDots();
      updateDots();
    });

    // Also call updateDots if embla is already initialized
    if (emblaApiMain.slideNodes().length > 0) {
      updateDots();
    }
  }

  emblaApiMain
    .on("destroy", removeThumbBtnsClickHandlers)
    .on("destroy", removeToggleThumbBtnsActive)
    .on("destroy", removePrevNextBtnsClickHandlers);

  emblaApiThumb
    .on("destroy", removeThumbBtnsClickHandlers)
    .on("destroy", removeToggleThumbBtnsActive);

  function findImageIndex(id, jump) {
    document
      .querySelectorAll(".embla-pdp__viewport .embla__slide")
      .forEach((s, i) => {
        let vid = s.getAttribute("data-variant-id");
        if (id == vid) {
          scrollToByElement(s, jump);
          return s;
        } else {
          return null;
        }
      });
  }

  function scrollToByElement(slideElement, jump) {
    const slideIndex = emblaApiMain.slideNodes().indexOf(slideElement);
    emblaApiMain.scrollTo(slideIndex, jump);
    emblaApiThumb.scrollTo(slideIndex, jump);
  }

  document.querySelectorAll(".image-jumper").forEach((el) => {
    el.addEventListener("click", (e) => {
      let _id = e.target.getAttribute("data-variant-id");
      if (!_id) {
      } else {
        findImageIndex(_id, false);
      }
    });
  });

  if (_variant) {
    findImageIndex(_variant, true);
  }
} else {
  return null;
}